document.addEventListener("alpine:init", () => {
  Alpine.data("notifications", (success, error, warning) => ({
    notifications: [],

    init() {
      if (Array.isArray(success))
        success.forEach((msg) => this.add(msg, "success"));
      if (Array.isArray(error)) error.forEach((msg) => this.add(msg, "error"));
      if (Array.isArray(warning))
        warning.forEach((msg) => this.add(msg, "warning"));
    },

    close(notification) {
      notification.show = false;
    },

    add(msg, type) {
      let len = this.notifications.push({
        text: msg,
        show: true,
        type: type,
        on: new Date(),
      });

      // hide notification after 3 seconds
      window.setTimeout(() => {
        this.notifications[len - 1].show = false;
      }, 3000);
    },
  }));
});
